export const getYearRange = () =>
  Array.from({ length: 101 }).map((_, index) =>
    (new Date().getFullYear() + (10 - index)).toString(),
  );
